import GuardrailEditor from './GuardrailEditor';

export default GuardrailEditor;
